<template>
  <div>
    <v-container fluid>
      <v-card elevation="0" class="pa-0">
        <v-card-title class="ma-0 pa-0">
          <v-row no-gutters class="ma-0" justify="end">
            <v-col cols="12">
              <h3 class="my-2 mx-2 primary--text">
                {{ $t("settings.landmark.title") }}
              </h3>
            </v-col>
            <!-- <v-spacer></v-spacer> -->
            <!-- <v-spacer v-if="$vuetify.breakpoint.mdAndUp"></v-spacer>
            <v-spacer v-if="$vuetify.breakpoint.mdAndUp"></v-spacer> -->
            <v-col cols="4">
              <v-text-field
                :label="$t('common.search')"
                v-model="search"
                :placeholder="$t('settings.landmark.searchPlaceHolder')"
                class="mx-2"
                outlined
                dense
              >
              </v-text-field>
            </v-col>
            <v-menu>
              <template #activator="{ on, attrs }">
                <v-btn class="ml-2" v-on="on" v-bind="attrs" icon>
                  <v-icon>mdi-menu</v-icon>
                </v-btn>
              </template>
              <v-list class="text-body-2">
                <v-list-item @click="showRightSideDrawer('LANDMARK')">
                  <v-list-item-icon>
                    <v-icon color="primary"> mdi-plus-circle </v-icon>
                  </v-list-item-icon>
                  <v-list-item-text>
                    {{ $t("settings.landmark.btnTitle") }}
                  </v-list-item-text>
                </v-list-item>
                <v-list-item @click="exportData">
                  <v-list-item-icon>
                    <v-icon color="success"> mdi-application-export </v-icon>
                  </v-list-item-icon>
                  <v-list-item-text>
                    {{ $t("common.excel") }}
                  </v-list-item-text>
                </v-list-item>
              </v-list>
            </v-menu>
          </v-row>
        </v-card-title>
        <v-data-table
          :footer-props="{ 'items-per-page-options': [50, 100, 150, 200, -1] }"
          id="landmarkTable"
          :headers="headers"
          :items="landmarkList"
          :search="search"
          :loading="loading"
          mobile-breakpoint="0"
          :options.sync="options"
          class="pa-0 mt-2 datatable"
        >
          <!-- :server-items-length="totalLandmark" -->
          <template v-slot:[`item._id`]="{ item }">
            <p class="my-0 py-0">
              {{
                options.page * options.itemsPerPage -
                  options.itemsPerPage +
                  landmarkList
                    .map(function(x) {
                      return x._id;
                    })
                    .indexOf(item._id) +
                  1
              }}
            </p>
          </template>
          <template v-slot:[`item.actions`]="{ item }">
            <v-row class="mx-auto" justify="center">
              <v-icon color="primary" class="mx-2" @click="editArea(item)"
                >mdi-pencil</v-icon
              >
              <v-icon color="red" @click="showDeleteDialog(item)"
                >mdi-delete</v-icon
              >
            </v-row>
          </template>
        </v-data-table>
      </v-card>
    </v-container>
  </div>
</template>

<script>
import { deleteLandmark } from "../methods/landmark/delete_landmark";
export default {
  data() {
    return {
      expanded: [],
      loading: false,
      search: "",
      variables: {
        limit: 10,
        skip: 0
      },
      options: {
        itemsPerPage: 50,
        page: 1
      },
      landmarkList: [],
      totalLandmark: 50
    };
  },
  computed: {
    headers() {
      return [
        {
          text: "#",
          align: "left",
          value: "_id",
          sortable: false,
          width: 10
        },
        {
          text: `${this.$t("settings.area.name")} (${this.$t("common.en")})`,
          align: "left",
          value: "nameEn",
          sortable: false,
          width: 100
        },
        {
          text: `${this.$t("settings.area.name")} (${this.$t("common.ar")})`,
          align: "left",
          sortable: false,
          value: "nameAr",
          width: 100
        },
        {
          text: `${this.$t("settings.blocks.areaName")} (${this.$t(
            "common.en"
          )})`,
          align: "left",
          value: "area.nameEn",
          sortable: false,
          width: 100
        },
        {
          text: `${this.$t("settings.blocks.areaName")} (${this.$t(
            "common.ar"
          )})`,
          align: "left",
          value: "area.nameAr",
          sortable: false,
          width: 100
        },
        {
          text: this.$t("settings.landmark.latitude"),
          align: "left",
          value: "latitude",
          sortable: false,
          width: 100
        },
        {
          text: this.$t("settings.landmark.longitude"),
          align: "left",
          value: "longitude",
          sortable: false,
          width: 100
        },
        {
          text: this.$t("common.actions"),
          value: "actions",
          sortable: false,
          align: "left",
          width: 100
        }
      ].map(header => {
        header.align = "center";
        return header;
      });
    }
  },
  watch: {
    // search(val) {
    //   this.loading = true;
    //   this.$apollo.queries.getLandmarks.refetch({
    //     input: {
    //       limit:
    //       this.options.itemsPerPage !== -1
    //         ? this.options.itemsPerPage
    //         : this.totalLandmark,
    //       skip:
    //         this.options.page * this.options.itemsPerPage -
    //         this.options.itemsPerPage
    //     },
    //     filter: {
    //       searchKey: val,
    //     },
    //   });
    //   this.loading = false;
    // },
    options() {
      this.$apollo.queries.getLandmarks.refetch({
        input: {
          limit:
            this.options.itemsPerPage !== -1
              ? this.options.itemsPerPage
              : this.totalLandmark,
          skip:
            this.options.page * this.options.itemsPerPage -
            this.options.itemsPerPage
        },
        filter: {
          searchKey: this.search
        }
      });
    }
  },
  apollo: {
    getLandmarks() {
      this.loading = true;
      return {
        query: require("@/settings/api/queries/landmark/get_landmark_query.graphql"),
        variables: {
          input: {
            limit: this.totalLandmark,
            skip: 0
          }
        },
        result({ data, loading }) {
          // , loading, networkStatus, refetch
          this.landmarkList = this.$format.cloneVariable(
            data.getLandmarks.landmarks
          );
          this.loading = loading;
          this.totalLandmark = data.getLandmarks.totalCount;
        }
      };
    }
  },
  mounted() {
    this.$root.$on("deleteItems", data => {
      if (data.module === "landmark") {
        const input = data.item._id;
        deleteLandmark(input).then(data => {
          if (data.data.deleteLandmark) {
            this.$apollo.queries.getLandmarks.refetch({
              limit:
                this.options.itemsPerPage !== -1
                  ? this.options.itemsPerPage
                  : this.totalLandmark,
              skip:
                this.options.page * this.options.itemsPerPage -
                this.options.itemsPerPage
            });
            this.$root.$emit("snackbar", {
              snackbar: true,
              text: this.$t("common.deleteSuccess"),
              color: "green"
            });
            this.$store.commit("DELETE_BTN_LOADING", false);
          }
        });
      }
    });
    this.$root.$on("landmarkTable", () => {
      this.options.itemsPerPage = 50;
      this.$set(this.options, this.options.itemsPerPage, 50);
    });
    this.$root.$on("refetchLandmark", () => {
      this.$apollo.queries.getLandmarks.refetch({
        limit:
          this.options.itemsPerPage !== -1
            ? this.options.itemsPerPage
            : this.totalLandmark,
        skip:
          this.options.page * this.options.itemsPerPage -
          this.options.itemsPerPage
      });
    });
    this.$root.$on("exportLandmark", () => {
      this.exportData();
    });
  },
  methods: {
    exportData() {
      this.$apollo.queries.getLandmarks
        .refetch({
          limit: 0,
          skip: 0
        })
        .then(data => {
          this.options.itemsPerPage = data.data.getLandmarks.totalCount;
          this.landmarkList = data.data.getLandmarks.landmarks;
          setTimeout(() => {
            this.htmlToExcel("landmarkTable", "landmark");
          }, 1000);
        });
    },
    showDeleteDialog(item) {
      this.$root.$emit("deleteDialog", {
        dialog: true,
        item: item,
        module: "landmark"
      });
    },
    showRightSideDrawer(item) {
      this.$store.commit("SHOW_RIGHTSIDE_DRAWER", true);
      this.$store.commit("APP_SETTINGS_FORMNAME", item);
    },
    editArea(item) {
      this.$store.commit("IS_EDIT_LANDMARK", true);
      this.$store.commit("EDIT_LANDMARK", item);
      this.$store.commit("APP_SETTINGS_FORMNAME", "LANDMARK");
      this.$store.commit("SHOW_RIGHTSIDE_DRAWER", true);
    }
  },
  beforeDestroy() {
    this.$root.$off("deleteItems");
    this.$root.$off("landmarkTable");
    this.$root.$off("refetchLandmark");
    this.$root.$off("exportLandmark");
  }
};
</script>
<style scoped>
.custom-data-table {
  background: #ffffff !important;
  box-shadow: 0 0 11px rgba(33, 33, 33, 0.2) !important;
}
.datatable >>> .v-data-footer__select {
  direction: ltr !important;
}
.datatable >>> .v-data-footer__pagination {
  direction: ltr !important;
}
</style>
